import { withReturnParam } from "./returnPath";

// Maps the current pathname to the login path used when a session is torn down
// (a dead / externally-invalidated OTP session). Its ONE import is returnPath.js,
// which the standalone vm test concatenates ahead of this file (a vm context
// cannot resolve ES imports) — keep it at that one, and keep it import-free
// itself, or the test stops loading.
//
//   /formulier/:id      -> resume the OTP fill-in for that intake form
//   /linkformulier/:id  -> resume the OTP fill-in for that share-link form
//   /uitnodiging/:token -> the generic login screen, with `register=true`
//   anything else       -> the generic login screen
//
// `expired=1` tells the login screen to show the "session expired" notice.
// Mirrors the query the intake templates' forceLogout already builds, so after
// re-auth OTP.vue bounces the user straight back to their form.
//
// The intake branch carries `type=intake` + the form key, NOT a Terugkeerpad:
// those parameters select *which login runs* (OTP.vue forwards `type` to
// /v1/auth/generate_otp, which issues a different one-time password), so they
// are not a destination and must never be combined with `r` — OTP.vue's
// created() reads `r` while its success path reads the form key, so the two
// branches would target different pages. Every other route takes the generic
// Terugkeerpad. See docs/adr/0028-return-path-is-origin-relative.md.
export function intakeLoginTarget(pathname, search) {
  const path = typeof pathname === "string" ? pathname : "";
  const intake = path.match(/^\/(formulier|linkformulier)\/([^/?#]+)/);

  if (intake) {
    const key =
      intake[1] === "linkformulier" ? "linkformulier" : "intakeformulier";
    return `/inloggen/otp?type=intake&${key}=${encodeURIComponent(
      intake[2],
    )}&expired=1`;
  }

  // De link uit de mail stuurt zelf met `register=true` naar de login (ADR-0145).
  // Deze route moet dat ook: met een dode sessie in de browser komt de bezoeker
  // hierlangs, en dan weigert de login een account van buiten de pagina.
  const login = path.startsWith("/uitnodiging/")
    ? "/inloggen?expired=1&register=true"
    : "/inloggen?expired=1";

  return withReturnParam(login, path, search);
}
